export enum EPlatform {
  BIGSCREEN = 'bigscreen',
  CONTROLLER = 'controller',
  EVENT = 'event',
}

export type TTrackingGameMode = 'single_player' | 'party' | 'event' | 'undefined'

export interface IEventMeta {
  gameCode?: string
  gameMode: TTrackingGameMode
  [key: string]: any
}

export interface IEvent {
  domain: string
  trigger: 'click' | 'auto'
  source: string
  meta?: IEventMeta
}

export interface IScreen {
  screenIdentifier: string
  abstractPath: string
  meta?: IEventMeta
}
